import { render, staticRenderFns } from "./BMWMotorradProcessExcellenceColumn.vue?vue&type=template&id=2ba29264&scoped=true&"
import script from "./BMWMotorradProcessExcellenceColumn.vue?vue&type=script&lang=js&"
export * from "./BMWMotorradProcessExcellenceColumn.vue?vue&type=script&lang=js&"
import style0 from "./BMWMotorradProcessExcellenceColumn.vue?vue&type=style&index=0&id=2ba29264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba29264",
  null
  
)

export default component.exports